
import AxiosClient from "../../../services/axios.services";

class PeriodoEvaluacionServices {
  getPeriodoEvaluaciones = params =>
    AxiosClient.get("/api/app/evaluacion_frecuencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getPeriodoEvaluacion = id =>
    AxiosClient.get(`/api/app/evaluacion_frecuencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  savePeriodoEvaluacion = data =>
    AxiosClient.post("/api/app/evaluacion_frecuencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPeriodoEvaluacion = (id, data) =>
    AxiosClient.put(
      `/api/app/evaluacion_frecuencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePeriodoEvaluacion = id =>
    AxiosClient.delete(`/api/app/evaluacion_frecuencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new PeriodoEvaluacionServices();